import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { FormBuilder } from 'shared-components/forms/form';
import { InviteShareBtn } from '../elements-buttons/invite-share-button';
import { fetchBooking } from '../app-main/actions/booking';
import { fetchAttendees } from '../app-main/actions/attendees';
import _ from 'lodash';
import { FormattedMessage, injectIntl } from 'react-intl';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';
import { Avatar } from 'shared-components/image/avatar';
import Copy from 'shared-components/icons/Copy';
import CopySecondary from 'shared-components/icons/CopySecondary';
import publicConfig from '../../../public-config';
import StickyNavigation from 'shared-components/partials-navigation/StickyNavigation';

const host = publicConfig.external_address;

class AttendeeSendInvitePageBody extends React.Component {
  constructor (props) {
    super(props);

    this.redirectToPreview = this.redirectToPreview.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.cancelAction = this.cancelAction.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleViewBookingDetails = this.handleViewBookingDetails.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.copyLinkAnalytics = this.copyLinkAnalytics.bind(this);
    this.inviteAnaltyics = this.inviteAnaltyics.bind(this);
    this.onParentFormSubmit = this.onParentFormSubmit.bind(this);
    this.onParentCopyClick = this.onParentCopyClick.bind(this);
    this.openShareSheet = this.openShareSheet.bind(this);
    this.formRef = React.createRef();
    this.copyFormRef = React.createRef();
  }

  componentDidMount () {
    const bookingId = _.get(this.props, 'routeParams.bookingId');
    const { dispatch, accessToken } = this.props;
    dispatch(fetchBooking(bookingId, accessToken));
    dispatch(fetchAttendees(bookingId));
  }

  onParentFormSubmit (e) {
    this.formRef.current.submitForm(e);
  }

  onParentCopyClick (e) {
    this.copyFormRef.current.props.actions.click(e);
  }

  onSubmit () {
    this.inviteAnaltyics(null, 'skip');
    this.redirectToPreview();
  }

  redirectToPreview () {
    const urlPrefix = SharedIntlProviderHOC.getUrlPrefix();
    const publicBookingId = _.get(this.props, 'booking.booking.pid');
    window.open(`${urlPrefix ? `/${urlPrefix}` : ''}/invite/${publicBookingId}`, '_blank');
  }

  async openShareSheet () {
    const urlPrefix = SharedIntlProviderHOC.getUrlPrefix();
    const prefix = urlPrefix ? `/${urlPrefix}` : '';
    const inviteDetails = _.get(this.props, 'booking.booking.public_fields');
    const pid = _.get(this.props, 'booking.booking.pid');
    const bookingId = _.get(this.props, 'routeParams.bookingId');
    const copyLink = `https://${host}${prefix}/invite/${pid}`;

    analyticsIntegrations.buttonClicked({
      button_name: 'Share invite',
      button_location: 'Send invite screen',
      invite_id: pid,
      label: bookingId
    });

    if (navigator.share) {
      try {
        await navigator.share({
          title: inviteDetails.guest_title,
          text: inviteDetails.guest_notes,
          url: copyLink
        });
      } catch (error) {
        console.error('Error sharing:', error);
      }
    }
  }

  copyLinkAnalytics () {
    const booking = _.get(this.props, 'booking.booking', {});

    const analyticProp = {
      label: _.get(booking, '_id'),
      wifi: !!_.get(booking, 'space.wifi_instructions'),
      getting_there: !!_.get(booking, 'space.getting_there'),
      origin: 'attendee-send-invite',
      invite_id: booking.pid,
      metro: _.get(booking, 'listing.metro'),
      use_type: _.get(booking, 'listing.use_type'),
      user_id: _.get(booking, 'guest.ssoid')
    };

    analyticsIntegrations.publicAttendee('attendee details: copy link', analyticProp);
  }

  cancelAction () {
    this.props.toggleModal('');
    this.inviteAnaltyics({}, 'cancel');

    this.props.cancelRedirect();
  }

  handleCancel (e) {
    e.preventDefault();
    this.props.toggleModal('cancelModal');
  }

  handleEdit (e) {
    e.preventDefault();
    const bookingId = _.get(this.props, 'routeParams.bookingId');
    this.props.dispatch(push(`/invite/add/${bookingId}`));
  }

  handleViewBookingDetails (e) {
    e.preventDefault();
    const bookingId = _.get(this.props, 'routeParams.bookingId');
    this.inviteAnaltyics(null, 'preview_invite');
    this.props.dispatch(push(`/inbox/${bookingId}`));
  }

  inviteAnaltyics (payload, action) {
    analyticsIntegrations.sendInvite(
      _.get(this.props, 'booking.booking'),
      payload,
      this.props.pageType,
      action
    );
  }

  render () {
    const publicBookingId = _.get(this.props, 'booking.booking.pid');
    const firstImg = _.get(this.props, 'booking.booking.listing.images[0].urlLarge');
    const inviteCreatorFirstName = _.get(this.props, 'booking.booking.guest.name.first');
    const inviteDetails = _.get(this.props, 'booking.booking.public_fields');
    const inviteGuestTimeBlock = inviteDetails ? inviteDetails.guest_schedule_str.split(/<br\/>/).map(item => item.replace(/<br\/>/g, '')) : '';
    const inviteAddress = _.get(this.props, 'booking.booking.space.address');
    const inviteCreatorAvatar = _.get(this.props, 'booking.booking.guest.avatar');
    return (
      <div className="AttendeeSendInvitePageBody ps-container-md-margin">
        <div className="ps-row">
          <div className="col-xs-12 col-md-6 imageHalf no-gutter-left position-relative overflow-hidden">
            <div className="listing-img position-relative" >
              <div
                className="listing-img-wrapper"
                style={{ backgroundImage: `url(${firstImg})` }}>
                <div className="mobile-invite-container">
                  <p className="stepCounter mobile"><FormattedMessage id='invite.attendee_add_details_page_body.step_two' defaultMessage="Step 2 of 2" /></p>
                  <h3 className="inviteIsReady mobile text-white text-center"><FormattedMessage id='invite.attendee_add_details_page_body.invite_is_ready' defaultMessage="Your invite is ready to share" /></h3>
                  <div className="flex center middle">
                    <button className="btn btn-link underline text-white white-hover" onClick={this.redirectToPreview}>Preview Invite</button>
                    <div className="dot-divider"></div>
                    <button className="btn btn-link underline text-white white-hover" onClick={this.handleEdit}><FormattedMessage id='invite.attendee_send_details_page_body.edit_invite' defaultMessage="Edit invite" /></button>
                  </div>
                </div>
              </div>
              {
                inviteDetails
                && <div className="invite-container w-100">
                  <img className="w-100 inviteImg" src={firstImg} alt="" />
                  <div className="bg-white inviteDetails relative overflow-hidden">
                    <h4 className="margin-md-bottom no-top-margin">{inviteDetails.guest_title}</h4>
                    <div className="flex">
                      <Avatar src={inviteCreatorAvatar} maxWidth="24px" />
                      <p className="no-bottom-margin"><FormattedMessage id='invite.attendee_send_invite_page_body.organized_by' defaultMessage="Organized by " />{inviteCreatorFirstName}</p>
                    </div>
                    <div className='padding-lg-top'>
                      <p className="h6 margin-sm-bottom no-top-margin"><FormattedMessage id='invite.attendee_send_invite_page_body.date_and_time' defaultMessage="Date and time" /></p>
                      {
                        inviteGuestTimeBlock.map((time, index) => (
                          <p key={`guest-invite-time-${index}`} className="text-gray-dark no-bottom-margin">{time}</p>
                        ))
                      }
                    </div>
                    <div className='padding-lg-top'>
                      <p className="h6 margin-sm-bottom no-top-margin"><FormattedMessage id='inbox.summary_props.address' defaultMessage="Address" /></p>
                      <p className="text-gray-dark no-bottom-margin">{inviteAddress}</p>
                    </div>
                    <div className='padding-lg-top'>
                      <p className="h6 margin-sm-bottom no-top-margin"><FormattedMessage id='invite.attendee_send_invite_page_body.event_description' defaultMessage="Event description" /></p>
                      <p className="text-gray-dark no-bottom-margin">{inviteDetails.guest_notes}</p>
                    </div>
                    <div className="invite-details-blur-bottom"></div>
                  </div>
                  <div className="inviteFooter bg-white padding-md-top padding-md-bottom">
                    <button className="text-center btn btn-link underline center-block" onClick={this.redirectToPreview}><FormattedMessage id="invite.attendee_add_details_page_body.preview_invite_first" defaultMessage="Preview invite"></FormattedMessage></button>
                  </div>
                </div>
              }
            </div>
          </div>
          <div className="col-xs-12 col-md-6 formHalf">
            <div className="formContainer">
              <p className="stepCounter"><FormattedMessage id='invite.attendee_send_invite_page_body.step_two' defaultMessage="Step 2 of 2" /></p>
              <h3 className="inviteIsReady"><FormattedMessage id='invite.attendee_send_invite_page_body.invite_is_ready' defaultMessage="Your invite is ready to share" /></h3>
              <p className="text-large text-gray-900 no-bottom-margin copy-the-link">
                <FormattedMessage id='invite.attendee_send_invite_page_body.copy_the_link' defaultMessage='Copy the link below to share with your guests. You can edit, access the invite link, and view the RSVP list on your booking details page.' />
              </p>
              <p className="copy-the-link mobile">
                <FormattedMessage id='invite.attendee_send_invite_page_body.share_your_invite' defaultMessage='Share your invite or copy the link below. You can edit, access the invite link, and view the RSVP list on your booking details page.' />
              </p>
              <FormBuilder
                ref={this.formRef}
                formname="attendeeSendInviteForm flex flex-grow"
                formStyle="standard"
                submitAction={this.onSubmit}
                containerClass='form-btn-container'
                buttonClass="hidden"
                useBootstrapGrid={false}
                buttonText={this.props.buttonText || this.props.intl.formatMessage({ id: 'invite.attendee_send_invite_page_body.finish', defaultMessage: 'Finish' })}
                formInputs={
                  [
                    {
                      custom: () => {
                        return (
                          <div className="">
                            <div className="margin-md-bottom">
                              <p className="h6 no-bottom-margin no-top-margin">
                                <FormattedMessage id='invite.attendee_send_invite_page_body.invite_link' defaultMessage='Invite link' />
                              </p>
                            </div>

                            <InviteShareBtn
                              ref={this.copyFormRef}
                              className="flex invite-btn"
                              inputContainerClassName="flex-grow"
                              pid={publicBookingId}
                              title={this.props.intl.formatMessage({ id: 'invite.attendee_send_invite_page_body.copy_link', defaultMessage: 'Copy link' })}
                              actions={{ click: this.copyLinkAnalytics }}
                              btnColor="btn-primary"
                              visibleMobile={true}
                              btnSize=""
                              iconInsideInput={(<div className="copy-icon" onClick={this.onParentCopyClick}><Copy width={20} height={20} /></div>)}
                              iconInsideBtn={(<div className="copy-icon" onClick={this.onParentCopyClick}><CopySecondary width={24} height={24} /></div>)}
                              alternateSuccessMsg={(<div className="copy-icon copy-success-msg text-brand-primary">
                                <FormattedMessage id="web_2.invite_share_btn.copied" defaultMessage="Copied!" />
                              </div>)}
                            />
                          </div>
                        );
                      }
                    }
                  ]
                }
              />
              <StickyNavigation>
                <div className="padding-xl-bottom padding-xl-top sticky-footer desktop bg-white flex space-between">
                  <button className="btn btn-link underline no-gutter-left" onClick={this.handleEdit}>
                    <FormattedMessage id='invite.attendee_send_invite_page_body.edit_invite' defaultMessage="Edit invite" />
                  </button>
                  <button className="btn btn-outline submit-btn" onClick={this.handleViewBookingDetails}>
                    <FormattedMessage id='invite.attendee_send_invite_page_body.view_booking_details' defaultMessage="View booking details" />
                  </button>
                </div>
                <div className="padding-xl-bottom padding-xl-top sticky-footer mobile bg-white flex space-between">
                  <button className="btn btn-link underline no-gutter-left" onClick={this.handleViewBookingDetails}>
                    <FormattedMessage id='invite.attendee_send_invite_page_body.booking_details' defaultMessage="Booking details" />
                  </button>
                  <button className="btn btn-primary" onClick={this.openShareSheet}>
                    <FormattedMessage id='invite.attendee_send_invite_page_body.share_invite' defaultMessage="Share invite" />
                  </button>
                </div>
              </StickyNavigation>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AttendeeSendInvitePageBody.propTypes = {
  whichModal: PropTypes.func,
  toggleModal: PropTypes.func,
  dispatch: PropTypes.func,
  accessToken: PropTypes.string,
  showCancel: PropTypes.bool,
  showSkip: PropTypes.bool,
  cancelRedirect: PropTypes.func,
  pageType: PropTypes.string,
  buttonText: PropTypes.string
};

function mapStateToProps (state) {
  const { auth, booking, attendees } = state;
  const { accessToken } = auth;

  return {
    accessToken,
    booking,
    attendees
  };
}

export default injectIntl(connect(mapStateToProps)(AttendeeSendInvitePageBody));
